import React from 'react';

export default function PartnerSection(props) {
  return (
    <section className="spg-section spg-team-partners">
      <div className="spg-kicker">Netzwerk</div>
      <h2 className="spg-title">stop+go &amp; Partner</h2>
      <p className="spg-lead" style={{ marginBottom: 24 }}>
        Als stop+go Partner profitieren wir von der technischen und logistischen
        Unterstützung der AMAG Import AG – mit Fokus auf VW, Audi, SEAT, Škoda und CUPRA.
      </p>
      {props.partnerText ? (
        <div
          className="spg-partner-logos"
          dangerouslySetInnerHTML={{ __html: props.partnerText }}
        />
      ) : null}
    </section>
  );
}
